import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { App } from './App';
import { msal } from './anmeldung';
import { meldeServiceWorkerAn } from './pwa';
import './stil.css';

const wurzel = document.getElementById('wurzel');

if (!wurzel) {
  throw new Error('Kein #wurzel im Dokument.');
}

/*
 * `initialize` und `handleRedirectPromise` vor dem ersten Rendern: Nach
 * der Rückkehr von Entra steht das Konto sonst erst beim zweiten Aufruf.
 */
await msal.initialize();
const ergebnis = await msal.handleRedirectPromise();

if (ergebnis?.account) {
  msal.setActiveAccount(ergebnis.account);
} else if (!msal.getActiveAccount() && msal.getAllAccounts()[0]) {
  msal.setActiveAccount(msal.getAllAccounts()[0] ?? null);
}

createRoot(wurzel).render(
  <StrictMode>
    <MsalProvider instance={msal}>
      <App />
    </MsalProvider>
  </StrictMode>,
);

// Nach dem Rendern: Die Anmeldung geht vor, der Worker trägt nur die
// Installierbarkeit (`pwa.ts`).
meldeServiceWorkerAn();
